/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetFormConfigurationModel } from './PetFormConfigurationModel';
import {
    PetFormConfigurationModelFromJSON,
    PetFormConfigurationModelFromJSONTyped,
    PetFormConfigurationModelToJSON,
} from './PetFormConfigurationModel';
import type { PetFormConfigurationResponseEventModel } from './PetFormConfigurationResponseEventModel';
import {
    PetFormConfigurationResponseEventModelFromJSON,
    PetFormConfigurationResponseEventModelFromJSONTyped,
    PetFormConfigurationResponseEventModelToJSON,
} from './PetFormConfigurationResponseEventModel';

/**
 * 
 * @export
 * @interface PetFormConfigurationResponseModel
 */
export interface PetFormConfigurationResponseModel {
    /**
     * 
     * @type {Array<PetFormConfigurationModel>}
     * @memberof PetFormConfigurationResponseModel
     */
    configs?: Array<PetFormConfigurationModel>;
    /**
     * 
     * @type {PetFormConfigurationResponseEventModel}
     * @memberof PetFormConfigurationResponseModel
     */
    event?: PetFormConfigurationResponseEventModel;
}

/**
 * Check if a given object implements the PetFormConfigurationResponseModel interface.
 */
export function instanceOfPetFormConfigurationResponseModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetFormConfigurationResponseModelFromJSON(json: any): PetFormConfigurationResponseModel {
    return PetFormConfigurationResponseModelFromJSONTyped(json, false);
}

export function PetFormConfigurationResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetFormConfigurationResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'configs': !exists(json, 'configs') ? undefined : ((json['configs'] as Array<any>).map(PetFormConfigurationModelFromJSON)),
        'event': !exists(json, 'event') ? undefined : PetFormConfigurationResponseEventModelFromJSON(json['event']),
    };
}

export function PetFormConfigurationResponseModelToJSON(value?: PetFormConfigurationResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'configs': value.configs === undefined ? undefined : ((value.configs as Array<any>).map(PetFormConfigurationModelToJSON)),
        'event': PetFormConfigurationResponseEventModelToJSON(value.event),
    };
}

